import { Alert, Snackbar, SxProps, Theme, useTheme } from "@mui/material";
import * as React from "react";
import { UserTypeContext } from "../context/userStatus";

interface SnackBarCompModal {
  showSnakbar: boolean;
  handleCloseSnakbar: any;
  snakbarMsg: string | React.ReactNode;
  type: any;
  sx?: SxProps<Theme>;
  alertSx?: SxProps<Theme>;
  icon?: React.ReactNode
  preventAutoHide?: boolean
}

const SnackBarComp = (props: SnackBarCompModal) => {
  return (
    <Snackbar
      open={props.showSnakbar}
      autoHideDuration={3000}
      onClose={props.handleCloseSnakbar}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert severity={props.type}>{props.snakbarMsg}</Alert>
    </Snackbar>
  );
};
export default SnackBarComp;

export const SnackBarCompV2 = (props: SnackBarCompModal) => {
  const extraProps: any = {}
  const snackbarProps: any = {}
  const { state: outcomeState } = React.useContext(UserTypeContext)
  const isDarkMode = useTheme().palette.mode === "dark" || outcomeState.isDarkMode
  if (props.icon) {
    extraProps.icon = props.icon
  }
  if (!props.preventAutoHide) {
    snackbarProps.autoHideDuration = 100000
  }
  return (
    <Snackbar
      open={props.showSnakbar}
      onClose={props.handleCloseSnakbar}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={props.sx ? props.sx : {}}
      {...snackbarProps}
    >
      <Alert severity={props.type} {...extraProps} sx={props.alertSx ? {
        ...props.alertSx,
        ...(isDarkMode ? {
          "& .MuiTypography-root": {
            color: "var(--white-background) !important",
          },
        } : {})

      } : {
        ...(isDarkMode ? {
          "& .MuiTypography-root": {
            color: "var(--white-background) !important",
          },
        } : {})
      }}>{props.snakbarMsg}</Alert>
    </Snackbar>
  );
};
